import "./Review.css";

const Review = () => {
    return (
        <div className='review'>
            <h4>Travail Parfait</h4>
            <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Suscipit tempore corrupti natus deleniti illum laudantium quis,
                quidem facilis amet cumque doloribus voluptas dolorem
                consectetur ut, repudiandae tenetur alias incidunt quae?
            </p>
        </div>
    );
};

export default Review;
